/**
 * @mixin
 */
export default {
	components: {},
	data() {
		return {
			hoverActive: false
		};
	},
	props: {
		ariaLabel: {
			type: String,
			default: ''
		},
		title: {
			type: String,
			default: ''
		},
		iconClassName: {
			type: String,
			default: ''
		},
		iconLeadingClassName: {
			type: String,
			default: ''
		},
		iconTrailingClassName: {
			type: String,
			default: ''
		},
		iconLeading: {
			type: Boolean,
			default: null
		},
		iconTrailing: {
			type: Boolean,
			default: null
		},
		labelText: {
			type: [String, Number],
			default: null
		},
		btnClick: {
			type: Function,
			default: () => {}
		},
		isLoading: {
			type: Boolean,
			default: false
		},
		hasLoaded: {
			type: Boolean,
			default: false
		},
		hasError: {
			type: Boolean,
			default: false
		},
		errorMessage: {
			type: String,
			default: ''
		},
		width: {
			type: String,
			default: 'auto'
		},
		/**
		 * The html button type
		 * @values button, submit, reset
		 */
		type: {
			type: String,
			default: 'button'
		},
		/**
		 * If true, button will retain the focus classes and add the is-selected class
		 */
		selected: {
			type: Boolean,
			default: false
		},
		link: {
			type: String,
			default: null
		},
		stopPropagation: {
			type: Boolean,
			default: false
		},
		badgeContent: {
			type: String
		},
		badgeLeading: {
			type: Boolean,
			default: null
		},
		badgeTrailing: {
			type: Boolean,
			default: null
		},
		badgeTopLeft: {
			type: Boolean,
			default: null
		},
		badgeTopRight: {
			type: Boolean,
			default: null
		},
		tooltip: {
			type: String
		}
	},
	methods: {
		onClick(e) {
			if (e) {
				//optional to stopPropagation,
				//because the component-document-clicked handler
				//wasn't being called in order to close
				//a component when another is clicked
				e.preventDefault();

				if (this.stopPropagation) {
					e.stopPropagation();
				}
			}

			this.$emit('click', e);

			if (e.target) {
				this.btnClick(e.target.value);
			}

			if (this.link) {
				window.location.assign(this.link);
			}
		},
		onMouseEnter(e) {
			this.hoverActive = true;
			this.$emit('mouseenter', e);
		},
		onMouseLeave(e) {
			this.hoverActive = false;
			this.$emit('mouseleave', e);
		}
	},
	computed: {
		showBadge() {
			let show = false;

			if (this.badgeContent) {
				show = true;
			}

			return show;
		}
	}
};
